import React, { useCallback } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Button, Theme } from "@material-ui/core";
import { Link } from "react-router-dom";

import { SearchInput } from "components";
import { useDispatch } from "react-redux";
import { slideActions } from "store/slide/slice";

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
}));

const SlideListToolbar: React.FC<any> = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const dispatch = useDispatch();

  const handleChange = useCallback(
    (event) => {
      dispatch(slideActions.setSearchText(event.target.value));
    },
    [dispatch]
  );

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to="/slides/add"
        >
          Add slide
        </Button>
      </div>
      <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search slide"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

SlideListToolbar.propTypes = {
  className: PropTypes.string,
};

export default SlideListToolbar;
